module.exports = __webpack_public_path__ + "img/img-business1.91a42c8b.png";